import { Box, ButtonBase, Stack } from '@mui/material';
import { DynamicIcon } from 'src/components';
import { Modals, useShowModals } from 'src/store/modals';
import { useScreenDimensions } from 'src/utils/system';
import { helpTabGroupLabelSx, helpTabItemSx } from './assistant-help-tab.styles';

interface NavItemProps {
  icon: string;
  label: string;
  onClick: () => void;
  testId?: string;
}

const NAV_ITEM_ICON_SIZE = 18;

const NavGroupLabel = ({ label }: { label: string }) => (
  <Box sx={helpTabGroupLabelSx}>{label}</Box>
);

const NavItem = ({ icon, label, onClick, testId }: NavItemProps) => (
  <ButtonBase onClick={onClick} sx={helpTabItemSx} data-testid={testId}>
    <DynamicIcon name={icon} library="lucide" size={NAV_ITEM_ICON_SIZE} />
    <span>{label}</span>
  </ButtonBase>
);

export const HelpAndSupportTab = () => {
  const { isMobile } = useScreenDimensions();
  const [showContactSupportModal, showShortcutsModal] = useShowModals(
    Modals.ContactSupportModal,
    Modals.ShortcutsModal,
  );

  const onHelpCenterClick = () => {
    window.open('https://support.onevisionresources.com/', '_blank');
  };

  const onDeveloperDocumentationClick = () => {
    window.open('https://docs.provisionapp.io', '_blank');
  };

  const onOneVisionAcademyClick = () => {
    window.open('https://learn.onevisionresources.com/', '_blank');
  };

  const onChangelogClick = () => {
    window.open('https://www.onevisionresources.com/changelog', '_blank');
  };

  const onContactSupportClick = () => {
    showContactSupportModal();
  };

  const onKeyboardShortcutsClick = () => {
    showShortcutsModal();
  };

  return (
    <Stack direction="column" data-testid="sidekick-help-tab">
      <NavGroupLabel label="Getting started" />
      <NavItem icon="book-open" label="Help Center" onClick={onHelpCenterClick} />
      <NavItem
        icon="braces"
        label="Developer Documentation"
        onClick={onDeveloperDocumentationClick}
      />
      <NavItem
        icon="graduation-cap"
        label="OneVision Academy"
        onClick={onOneVisionAcademyClick}
      />
      <NavItem icon="scroll-text" label="Changelog" onClick={onChangelogClick} />

      <NavGroupLabel label="Support" />
      <NavItem
        icon="message-circle"
        label="Contact support"
        onClick={onContactSupportClick}
        testId="sidekick-help-contact-support"
      />
      {!isMobile && (
        <NavItem
          icon="keyboard"
          label="Keyboard shortcuts"
          onClick={onKeyboardShortcutsClick}
          testId="sidekick-help-keyboard-shortcuts"
        />
      )}
    </Stack>
  );
};
